import { isLessThanSixChars } from '@/helpers/validation.js'

export default {
  methods: {
    isEmailInvalid(value) {
      return !On.helpers.validateEmail(value) ? this.$t('errors.invalid_email') : false
    },

    isPasswordInvalid(value) {
      return this.actionType == 'signUp' && isLessThanSixChars(value)
        ? this.$t('errors.password_too_short')
        : false
    },

    isPasswordConfirmationInvalid(value) {
      return value !== this.formData.password
        ? this.$t('errors.invalid_password_confirmation')
        : false
    },
  },
}
